package components.company.pricelist

import components.exportHeading
import it.neckar.lizergy.model.price.PriceListExportCategory
import react.*
import services.UiActions

/**
 * The heading of a price list table, with the spreadsheet export of its category next to it.
 */
fun RBuilder.priceListExportHeading(category: PriceListExportCategory) {
  exportHeading(category.label) {
    UiActions.downloadPriceListXlsx(category)
  }
}
